/* tslint:disable */
/* eslint-disable */
/**
 * Bookings API
 * Bookings API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetReservation200Response
 */
export interface GetReservation200Response {
    /**
     * 
     * @type {string}
     * @memberof GetReservation200Response
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof GetReservation200Response
     */
    externalId: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetReservation200Response
     */
    name: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetReservation200Response
     */
    email: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetReservation200Response
     */
    surname: string;
    /**
     * 
     * @type {string}
     * @memberof GetReservation200Response
     */
    phoneNumber: string | null;
    /**
     * 
     * @type {number}
     * @memberof GetReservation200Response
     */
    diners: number;
    /**
     * 
     * @type {string}
     * @memberof GetReservation200Response
     */
    customerComments: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetReservation200Response
     */
    zone: string;
    /**
     * 
     * @type {string}
     * @memberof GetReservation200Response
     */
    zoneId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetReservation200Response
     */
    source: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetReservation200Response
     */
    creationTime: string;
    /**
     * 
     * @type {string}
     * @memberof GetReservation200Response
     */
    dateTime: string;
    /**
     * 
     * @type {string}
     * @memberof GetReservation200Response
     */
    endTime: string;
    /**
     * 
     * @type {string}
     * @memberof GetReservation200Response
     */
    locationId: string;
    /**
     * 
     * @type {string}
     * @memberof GetReservation200Response
     */
    tabId: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetReservation200Response
     */
    policy: string;
    /**
     * 
     * @type {number}
     * @memberof GetReservation200Response
     */
    policyAmount: number;
    /**
     * 
     * @type {string}
     * @memberof GetReservation200Response
     */
    policyMethod: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof GetReservation200Response
     */
    policyCharged: boolean;
    /**
     * 
     * @type {string}
     * @memberof GetReservation200Response
     */
    policyCancellationUntil?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetReservation200Response
     */
    status: string;
    /**
     * 
     * @type {boolean}
     * @memberof GetReservation200Response
     */
    notify: boolean;
    /**
     * 
     * @type {string}
     * @memberof GetReservation200Response
     */
    reminderNotifiedAt?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetReservation200Response
     */
    updatedAt?: string;
    /**
     * 
     * @type {string}
     * @memberof GetReservation200Response
     */
    cancelledAt?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetReservation200Response
     */
    promotionCode?: string | null;
}

/**
 * Check if a given object implements the GetReservation200Response interface.
 */
export function instanceOfGetReservation200Response(value: object): value is GetReservation200Response {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('externalId' in value) || value['externalId'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('email' in value) || value['email'] === undefined) return false;
    if (!('surname' in value) || value['surname'] === undefined) return false;
    if (!('phoneNumber' in value) || value['phoneNumber'] === undefined) return false;
    if (!('diners' in value) || value['diners'] === undefined) return false;
    if (!('customerComments' in value) || value['customerComments'] === undefined) return false;
    if (!('zone' in value) || value['zone'] === undefined) return false;
    if (!('source' in value) || value['source'] === undefined) return false;
    if (!('creationTime' in value) || value['creationTime'] === undefined) return false;
    if (!('dateTime' in value) || value['dateTime'] === undefined) return false;
    if (!('endTime' in value) || value['endTime'] === undefined) return false;
    if (!('locationId' in value) || value['locationId'] === undefined) return false;
    if (!('tabId' in value) || value['tabId'] === undefined) return false;
    if (!('policy' in value) || value['policy'] === undefined) return false;
    if (!('policyAmount' in value) || value['policyAmount'] === undefined) return false;
    if (!('policyMethod' in value) || value['policyMethod'] === undefined) return false;
    if (!('policyCharged' in value) || value['policyCharged'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('notify' in value) || value['notify'] === undefined) return false;
    return true;
}

export function GetReservation200ResponseFromJSON(json: any): GetReservation200Response {
    return GetReservation200ResponseFromJSONTyped(json, false);
}

export function GetReservation200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetReservation200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'externalId': json['externalId'],
        'name': json['name'],
        'email': json['email'],
        'surname': json['surname'],
        'phoneNumber': json['phoneNumber'],
        'diners': json['diners'],
        'customerComments': json['customerComments'],
        'zone': json['zone'],
        'zoneId': json['zoneId'] == null ? undefined : json['zoneId'],
        'source': json['source'],
        'creationTime': json['creationTime'],
        'dateTime': json['dateTime'],
        'endTime': json['endTime'],
        'locationId': json['locationId'],
        'tabId': json['tabId'],
        'policy': json['policy'],
        'policyAmount': json['policyAmount'],
        'policyMethod': json['policyMethod'],
        'policyCharged': json['policyCharged'],
        'policyCancellationUntil': json['policyCancellationUntil'] == null ? undefined : json['policyCancellationUntil'],
        'status': json['status'],
        'notify': json['notify'],
        'reminderNotifiedAt': json['reminderNotifiedAt'] == null ? undefined : json['reminderNotifiedAt'],
        'updatedAt': json['updatedAt'] == null ? undefined : json['updatedAt'],
        'cancelledAt': json['cancelledAt'] == null ? undefined : json['cancelledAt'],
        'promotionCode': json['promotionCode'] == null ? undefined : json['promotionCode'],
    };
}

export function GetReservation200ResponseToJSON(json: any): GetReservation200Response {
    return GetReservation200ResponseToJSONTyped(json, false);
}

export function GetReservation200ResponseToJSONTyped(value?: GetReservation200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'externalId': value['externalId'],
        'name': value['name'],
        'email': value['email'],
        'surname': value['surname'],
        'phoneNumber': value['phoneNumber'],
        'diners': value['diners'],
        'customerComments': value['customerComments'],
        'zone': value['zone'],
        'zoneId': value['zoneId'],
        'source': value['source'],
        'creationTime': value['creationTime'],
        'dateTime': value['dateTime'],
        'endTime': value['endTime'],
        'locationId': value['locationId'],
        'tabId': value['tabId'],
        'policy': value['policy'],
        'policyAmount': value['policyAmount'],
        'policyMethod': value['policyMethod'],
        'policyCharged': value['policyCharged'],
        'policyCancellationUntil': value['policyCancellationUntil'],
        'status': value['status'],
        'notify': value['notify'],
        'reminderNotifiedAt': value['reminderNotifiedAt'],
        'updatedAt': value['updatedAt'],
        'cancelledAt': value['cancelledAt'],
        'promotionCode': value['promotionCode'],
    };
}

